// extracted by mini-css-extract-plugin
module.exports = {"routesTipsResult":"styles_routesTipsResult__ocqZb","scrollFormContainer":"styles_scrollFormContainer__1c06C"};